import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { RegisterComponent } from './register';
import { LoginComponent } from './login';
import { ChangelogComponent } from './changelog/changelog.component';
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { PageAuthGuard } from './services/auth/page-auth.guard';

const appRoutes: Routes = [
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: '', redirectTo: '/home', pathMatch: 'full' }
    ]
  },
  // Private layout
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: 'logout', component: LoginComponent, canActivate: [AuthGuard] },
      { path: 'changelog', component: ChangelogComponent, canActivate: [AuthGuard] },
      { path: 'users', component: UserListComponent, canActivate: [AuthGuard] },
      {
        path: 'dashboard', loadComponent: () => import('./pages/dashboard/dashboard.component').then(a => a.DashboardComponent), data: { action: "view", module: "dashboardManagement" },
        canActivate: [PageAuthGuard],
      },

      {
        path: 'home', loadComponent: () => import('./pages/home/home/home.component').then(a => a.HomeComponent), data: { action: "view", module: "orderProcessingManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'reatail-counter', loadComponent: () => import('./pages/retail-counter/retail-counter/retail-counter.component').then(a => a.RetailCounterComponent), data: { action: "view", module: "retailCounterManagement" },
        canActivate: [PageAuthGuard],
      },
      // {
      //   path: 'order-stock', loadComponent: () => import('./pages/stock-management/stock-order/stock-order.component').then(a => a.StockOrderComponent), data: { action: "view", module: "stockManagement" },
      //   canActivate: [PageAuthGuard],
      // },
      {
        path: 'add-stock', loadComponent: () => import('./pages/stock-management/add-stock/add-stock.component').then(a => a.AddStockComponent), data: { action: "add", module: "stockManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'stock-library', loadComponent: () => import('./pages/stock-management/stock-library/stock-library.component').then(a => a.StockLibraryComponent), data: { action: "view", module: "stockManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'product-library', loadComponent: () => import('./pages/product-library-management/product-library-list/product-library-list.component').then(a => a.ProductLibraryListComponent), data: { action: "view", module: "productLibrary" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'rental-product-library', loadComponent: () => import('./pages/product-library-management/rental-product-library-list/rental-product-library-list.component').then(a => a.RentalProductLibraryListComponent), data: { action: "view", module: "productLibrary" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'rakeemart-product-library', loadComponent: () => import('./pages/product-library-management/inhouse-product-library-list/inhouse-product-library-list.component').then(a => a.InhouseProductLibraryListComponent), data: { action: "view", module: "inhouseProductLibrary" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'delivery-agent/all', loadComponent: () => import('./pages/delivery-agent/delivery-agent-list/delivery-agent-list.component').then(a => a.DeliveryAgentListComponent), data: { action: "view", module: "deliveryManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'delivery-agent/create', loadComponent: () => import('./pages/delivery-agent/add-edit-delivery-agent/add-edit-delivery-agent.component').then(a => a.AddEditDeliveryAgentComponent), data: { action: "add", module: "deliveryManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'delivery-agent/update/:id', loadComponent: () => import('./pages/delivery-agent/add-edit-delivery-agent/add-edit-delivery-agent.component').then(a => a.AddEditDeliveryAgentComponent), data: { action: "update", module: "deliveryManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'service-provider/all', loadComponent: () => import('./pages/service-provider-management/service-provider-list/service-provider-list.component').then(a => a.ServiceProviderListComponent), data: { action: "view", module: "serviceProviderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'service-provider/create', loadComponent: () => import('./pages/service-provider-management/add-edit-service-provider/add-edit-service-provider.component').then(a => a.AddEditServiceProviderComponent), data: { action: "add", module: "serviceProviderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'service-provider/update/:id', loadComponent: () => import('./pages/service-provider-management/add-edit-service-provider/add-edit-service-provider.component').then(a => a.AddEditServiceProviderComponent), data: { action: "update", module: "serviceProviderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'service-booking/all', loadComponent: () => import('./pages/service-booking-management/service-booking-list/service-booking-list.component').then(a => a.ServiceBookingListComponent), data: { action: "view", module: "serviceProviderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'service-booking/view/:id', loadComponent: () => import('./pages/service-booking-management/service-booking-view/service-booking-view.component').then(a => a.ServiceBookingViewComponent), data: { action: "view", module: "serviceProviderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'faq', loadComponent: () => import('./pages/help/help.component').then(a => a.HelpComponent),
        canActivate: [],
      },
      {
        path: 'retailer-orders', loadComponent: () => import('./pages/order-management/order-list/order-list.component').then(a => a.OrderListComponent), data: { action: "view", module: "retailerOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'place-retailer-order', loadComponent: () => import('./pages/order-management/add-edit-order/add-edit-order.component').then(a => a.AddEditOrderComponent), data: { action: "add", module: "retailerOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'view-order-info/:id', loadComponent: () => import('./pages/order-management/view-order-info/view-order-info.component').then(a => a.ViewOrderInfoComponent), data: { action: "view", module: "retailerOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'supplier-deliveries', loadComponent: () => import('./pages/order-management/supplier-delivery-list/supplier-delivery-list.component').then(a => a.SupplierDeliveryListComponent), data: { action: "view", module: "retailerOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'supplier-deliveries/:id', loadComponent: () => import('./pages/order-management/supplier-delivery-view/supplier-delivery-view.component').then(a => a.SupplierDeliveryViewComponent), data: { action: "view", module: "retailerOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'user-orders', loadComponent: () => import('./pages/user-order-management/user-order-list/user-order-list.component').then(a => a.UserOrderListComponent), data: { action: "view", module: "userOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'user-counter-orders', loadComponent: () => import('./pages/user-order-management/user-counter-order-list/user-counter-order-list.component').then(a => a.UserCounterOrderListComponent), data: { action: "view", module: "userCounterManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'detail-user-order/:id/:type', loadComponent: () => import('./pages/user-order-management/user-order-view/user-order-view.component').then(a => a.UserOrderViewComponent), data: { action: "info", module: "userOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'detail-user-order/:id', loadComponent: () => import('./pages/user-order-management/user-order-view/user-order-view.component').then(a => a.UserOrderViewComponent), data: { action: "info", module: "userOrderManagement" },
        canActivate: [PageAuthGuard],
      },
      {
        path: 'detail-counter-order/:id', loadComponent: () => import('./pages/user-order-management/user-counter-order-view/user-counter-order-view.component').then(a => a.UserCounterOrderViewComponent), data: { action: "info", module: "userCounterManagement" },
        canActivate: [PageAuthGuard],
      },
    ],
  },
  {
    path: 'error-page', component: ErrorPageComponent,
  },
  // otherwise redirect to home
  { path: '**', redirectTo: 'error-page' },
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top' });
